import React, { Component } from 'react'
import MyNavbar from "../../components/Navbar/MyNavbar";
import TimesheetSystem from '../../components/Ticket/TimesheetSystem/TimesheetSystem';
import TimesheetSystemApproval from '../../components/Ticket/TimesheetSystem/TimesheetSystemApproval/TimesheetSystemApproval';
export default class TimesheetSystemApprovalPage extends Component {
    
    render() {
        return (
            <div>
                 <MyNavbar />
                 <TimesheetSystemApproval/>
            </div>
        )
    }
}